import { render, staticRenderFns } from "./SystemMessageUpdate.vue?vue&type=template&id=3a6271a2&scoped=true&"
import script from "./SystemMessageUpdate.vue?vue&type=script&lang=js&"
export * from "./SystemMessageUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageUpdate.vue?vue&type=style&index=0&id=3a6271a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6271a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
